export class ContactFormModel {
constructor(
    public fullName: string,
    public emailId: string,
    public selectBox: string,
    public descriptionTxt: string
){}
}

